module.exports = __webpack_public_path__ + "img/logo2.44661e9c.png";